import React, { useEffect, useState } from "react";
import { ChartBox } from "./";
import http from "../../../../../services/http";
import { CHART_FILTERS } from "../../../../../constant";
import { generateChartConfig } from "../../../../../utils";

function TotalTimeSpent() {
  // STATES
  const [selectedFilter, setselectedFilter] = useState(CHART_FILTERS[0].value);
  const [data, setData] = useState([]);

  // HELPERS
  const getStats = async () => {
    const { data } = await http.get(`time-spent/${selectedFilter}`);
    setData(data);
  };

  // CONST VALS
  const dayFilter = selectedFilter === CHART_FILTERS[0].value;
  const category = dayFilter ? "session_time" : "session_date";
  const categories = data.map((item) => item[category]);
  const chartOptions = generateChartConfig({
    categories,
    isDay: dayFilter,
    suffix: "m",
  });
  const chartData = data.map((item) => item.total_duration.toFixed(2));

  // HANDLERS
  const setFilter = (val) => {
    setselectedFilter(val);
  };

  // HOOKS
  useEffect(() => {
    getStats();
  }, [selectedFilter]);

  return (
    <ChartBox
      title="Total Time Spent By Users"
      data={chartData}
      config={chartOptions}
      selectedFilter={selectedFilter}
      setFilter={setFilter}
    />
  );
}

export default TotalTimeSpent;
